
import { Container } from 'react-responsive-grid'
import React from "react"
import PropTypes from "prop-types"
import Link from "gatsby-link"
import Helmet from "react-helmet"
import { rhythm, scale } from '../utils/typography'

export default class Template extends React.Component {
  static propTypes = {
    children: PropTypes.func,
  }

  render() {
    const { location, children } = this.props;
    let header;
    if (location.pathname === '/') {
      header = (
        <div>
        <h1
          style={{
            ...scale(2.6),
            marginBottom: 0,
            marginTop: 0,
          }}
        >
          <Link
            style={{
              boxShadow: 'none',
              textDecoration: 'none',
              color: 'inherit',
            }}
            to={'/'}
          >
            juha.net
          </Link>
        </h1>
        <h3
          style={{
            marginBottom: rhythm(1.2),
            marginTop: 5,
            marginBottom: 50,
          }}
        >
          <Link
            style={{
              boxShadow: 'none',
              textDecoration: 'none',
              color: 'grey',
            }}
            to={'/'}
          >
            #aviation #dev #photography #tech
          </Link>
        </h3>
        </div>
      )
    } else {
      header = (
        <h3
          style={{
            fontFamily: 'Montserrat, sans-serif',
            marginTop: 0,
          }}
        >
          <Link
            style={{
              boxShadow: 'none',
              textDecoration: 'none',
              color: 'inherit',
            }}
            to={'/'}
          >
            juha.net
          </Link>
          <Link
            style={{
              boxShadow: 'none',
              textDecoration: 'none',
              color: 'grey',
              marginLeft: 10,
            }}
            to={'/'}
          >
            #aviation #dev #photography #tech
          </Link>
        </h3>
      )
    }

    return (
      <Container
        style={{
          maxWidth: rhythm(26),
          padding: `${rhythm(1.5)} ${rhythm(3/4)}`,
        }}
      >
        {header}
        {children()}
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.js